import React, { useEffect, useState } from 'react';
import { FaIcon } from './Icons';
import ToggleSwitch from './ToggleSwitch';
import styles from './CollapsibleSection.module.scss';
import TooltipWithRef from './Tooltip.jsx';

function Heading({ level = 4, title }) {
  const Tag = `h${level}`;
  return <Tag>{title}</Tag>;
}

function CollapsibleSection({
    title, 
    description = null, 
    isEnabled, 
    defaultEnabled = false, 
    initialCollapsed = false,
    collapsed,
    onToggleEnabled, 
    enableToggle = false, 
    buttons, 
    collapseHeadingSize = 5,
    style,
    children}) {
    const [isCollapsed, setIsCollapsed] = useState(collapsed || initialCollapsed);
    const [internalEnabled, setInternalEnabled] = useState(defaultEnabled);

    useEffect(() => {
        if (collapsed !== undefined) {
            setIsCollapsed(collapsed);
        }
    }, [collapsed]);

    const enabled = isEnabled !== undefined ? isEnabled : internalEnabled;

    const handleToggleEnabled = () => {
        const newVal = !enabled;
        if (onToggleEnabled) {
            onToggleEnabled(newVal);
        }
        if (isEnabled === undefined) {
            setInternalEnabled(newVal);
        }
    };

    return (
        <div className={styles['collapse-section']} style={style}>
            <div className={styles['section-header']} onClick={() => setIsCollapsed(prev => !prev)}>
                <div className={styles['header-title']}>
                    <div className={styles['title-container']}>
                        <FaIcon className={styles[`collapse-size-${collapseHeadingSize}`]} type={isCollapsed ? 'chevron-right' : 'chevron-down'}/>
                        <Heading title={title} level={collapseHeadingSize} />
                    </div>
                    {description && <p className='description'>{description}</p>}
                </div>
                {
                    enableToggle && 
                    <TooltipWithRef onClick={e => e.stopPropagation()} title={I18n.t('collapse_section_toggle_tooltip')} trigger='hover'>
                        <ToggleSwitch name='is_selection' isOn={enabled} defaultIsOn={defaultEnabled} handleToggle={handleToggleEnabled} />
                    </TooltipWithRef>
                }
                {buttons && <div onClick={(e) => e.stopPropagation()}>{buttons}</div>}
            </div>
            {!isCollapsed && (
                <div className={styles['collapse-content']}>
                    {children}
                </div>
            )}
        </div>
    );
}

export default CollapsibleSection;